import _ from 'underscore';
//import _s from 'underscore.string';
export default (editor, config = {}) => {
  var commands = editor.Commands;
}
